<template>
  <div>
    <div class="filter-bar">
      <span @click="selectYearmonth">
        年月 {{ yearmonth }}
        <i class="caret"></i>
      </span>
      <span>
        {{ querytype }}
        <i class="caret"></i>
        <select
          class="filter-item__select"
          v-model="querytype"
          @change="searchDay"
        >
          <option :value="'全部'">全部</option>
          <option :value="'产品'">产品</option>
          <option :value="'按工作中心'">按工作中心</option>
        </select>
      </span>
    </div>

    <div class="canvas-box">
      <canvas id="myChart" class="myChart"></canvas>
    </div>

    <div class="list-box" v-if="querytype == '全部' && result.qcdayitems">
      <div class="list-box-col">
        <p class="list-box-col__title">日期</p>
        <p
          class="list-box-col__content"
          v-for="item in result.qcdayitems"
          :key="item.text"
        >
          {{ item.text }}
        </p>
        <!-- <p class="list-box-col__content">本年累计</p> -->
      </div>
      <div
        class="list-box-col list-box-active"
        @click="initChart(deal2(result.details[0]))"
      >
        <p class="list-box-col__title">送检批</p>
        <p
          class="list-box-col__content"
          style="color: #2eadf5"
          v-for="item in result.qcdayitems"
          :key="item.text"
        >
          {{ item.amount || 0 }}
        </p>
        <!-- <p class="list-box-col__content">{{ result.details[0].amount }}</p> -->
      </div>
      <div
        class="list-box-col list-box-active"
        @click="initChart(deal2(result.details[1]))"
      >
        <p class="list-box-col__title">合格批</p>
        <p
          class="list-box-col__content"
          style="color: #e44959"
          v-for="item in result.qcdayitems"
          :key="item.text"
        >
          {{ item.okcount || 0 }}
        </p>
        <!-- <p class="list-box-col__content">{{ result.details[1].amount }}</p> -->
      </div>
      <div
        class="list-box-col list-box-active"
        @click="initChart(deal2(result.details[2]))"
      >
        <p class="list-box-col__title">不合格批</p>
        <p
          class="list-box-col__content"
          style="color: #000"
          v-for="item in result.qcdayitems"
          :key="item.text"
        >
          {{ item.ngcount || 0 }}
        </p>
        <!-- <p class="list-box-col__content">{{ result.details[2].amount }}</p> -->
      </div>
      <div
        class="list-box-col list-box-active"
        @click="initChart(deal2(result.details[3]))"
      >
        <p class="list-box-col__title">批次合格率%</p>
        <p
          class="list-box-col__content"
          style="color: #16b603"
          v-for="item in result.qcdayitems"
          :key="item.text"
        >
          {{ item.okrate || 0 }}
        </p>
        <!-- <p class="list-box-col__content">{{ result.details[2].amount }}</p> -->
      </div>
    </div>

    <div class="list-cells" v-if="querytype != '全部' && result.qcdayitems">
      <div
        class="list-cell"
        v-for="(item, index) in result.details"
        :key="index"
      >
        <div class="list-cell__main" @click="open(index)">
          <div class="list-cell__index">
            <span>{{ index + 1 }}</span>
          </div>
          <div class="list-cell__content">
            <p v-if="querytype === '产品'">
              {{ item.pr_code }} {{ item.pr_detail }}
            </p>
            <p v-if="querytype === '按工作中心'">{{ item.qc_wcname }}</p>
            <p>{{ item.amount || 0 }}</p>
          </div>
          <div class="list-cell__toggle">
            <span v-if="opened == index"
              ><i class="iconfont icon-shang"></i
            ></span>
            <span v-else><i class="iconfont icon-xia"></i></span>
          </div>
        </div>
        <div class="weui-cells" v-if="opened == index">
          <div class="weui-cell gray" v-for="day in result.days" :key="day">
            <div class="weui-cell__bd">{{ day }}日</div>
            <div class="weui-cell__ft">{{ item["amount" + day] || 0 }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import F2 from '@antv/f2'
import F2 from "@antv/f2/lib/index";
import ScrollBar from "@antv/f2/lib/plugin/scroll-bar";
import "@antv/f2/lib/interaction/pan";

export default {
  data() {
    var year = new Date().getFullYear();
    var month = new Date().getMonth() + 1;
    var yearmonth;
    if (month < 10) yearmonth = year + "0" + month;
    else yearmonth = year + "" + month;

    return {
      yearmonth,
      result: {},
      querytype: "全部",
      querytypeObj: {
        全部: "detail",
        产品: "prod",
        按工作中心: "workcenter",
      },
      opened: -1,
      chart: null,
    };
  },

  mounted() {
    this.searchDay();
    window.addEventListener("resize", this.onResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
    if (this.chart) {
      this.chart.destroy();
    }
  },
  methods: {
    searchDay() {
      let me = this;

      const params = {
        yearmonth: me.yearmonth,
        querytype: me.querytypeObj[me.querytype],
      };
      me.$ajax({
        url: "/api/qc/report/fqcAnalysisDay",
        params,
      }).then(function (res) {
        if (res.success) {
          me.result = res.data;
          me.initChart(me.deal(me.result.qcdayitems));
        }
      });
    },
    onResize() {
      var chart = this.chart;
      if (chart) {
        this.chart = chart.destroy();
        this.initChart(this.deal(this.result.qcdayitems));
      }
    },
    initChart(data) {
      var chart = this.chart;
      if (chart) {
        chart.changeData(data);
        return;
      }
      this.chart = chart = new F2.Chart({
        id: "myChart",
        width: window.innerWidth,
        height: Math.min(window.innerHeight * 0.6, 300),
        pixelRatio: window.devicePixelRatio,
        plugins: ScrollBar,
      });
      chart.source(data, {
        index: {
          type: "linear",
          tickInterval: 1,
          min: -1,
          max: window.innerWidth > window.innerHeight ? 12 : 6,
          formatter: (i) =>
            i > -1 && i < 31
              ? [
                  "1日",
                  "2日",
                  "3日",
                  "4日",
                  "5日",
                  "6日",
                  "7日",
                  "8日",
                  "9日",
                  "10日",
                  "11日",
                  "12日",
                  "13日",
                  "14日",
                  "15日",
                  "16日",
                  "17日",
                  "18日",
                  "19日",
                  "20日",
                  "21日",
                  "22日",
                  "23日",
                  "24日",
                  "25日",
                  "26日",
                  "27日",
                  "28日",
                  "29日",
                  "30日",
                  "31日",
                ][i]
              : null,
        },
      });

      chart
        .interval()
        .position("index*value")
        .color("type", (val) => {
          if (val === "送检批次") {
            return "#2eadf5";
          } else if (val === "合格批数") {
            return "#e44959";
          } else if (val === "不合格批数") {
            return "#000";
          } else if (val === "批次合格率%") {
            return "#16b603";
          }
        })
        .adjust({
          type: "dodge",
          marginRatio: 0.05, // 设置分组间柱子的间距
        });

      // 定义进度条
      chart.scrollBar({
        mode: "x",
        xStyle: {
          backgroundColor: "#e8e8e8",
          fillerColor: "#808080",
          offsetY: -2,
        },
      });
      chart.interaction("pan");
      chart.render();
    },
    deal(data) {
      if (!data) return;
      let arr = [
        { index: -1, type: "送检批次", value: 0 },
        { index: 31, type: "送检批次", value: 0 },
      ];
      for (let i = 0; i < 31; i++) {
        arr.push(
          {
            text: data[i]?.text,
            type: "送检批次",
            index: i,
            value: data[i]?.amount || 0,
          },
          {
            text: data[i]?.text,
            type: "合格批数",
            index: i,
            value: data[i]?.okcount || 0,
          },
          {
            text: data[i]?.text,
            type: "不合格批数",
            index: i,
            value: data[i]?.ngcount || 0,
          },
          {
            text: data[i]?.text,
            type: "批次合格率%",
            index: i,
            value: data[i]?.okrate || 0,
          }
        );
      }
      return arr;
    },
    deal2(data) {
      if (!data) return;
      let arr = [
        { index: -1, type: data.text, value: 0 },
        { index: 31, type: data.text, value: 0 },
      ];
      for (let i = 0; i < 31; i++) {
        arr.push({
          index: i,
          text: i + "日",
          type: data.text,
          value: data["amount" + (i + 1)] || 0,
        });
      }
      return arr;
    },
    selectYearmonth() {
      var me = this,
        year = new Date().getFullYear(),
        years = [],
        months = [
          { value: "01", label: "1月" },
          { value: "02", label: "2月" },
          { value: "03", label: "3月" },
          { value: "04", label: "4月" },
          { value: "05", label: "5月" },
          { value: "06", label: "6月" },
          { value: "07", label: "7月" },
          { value: "08", label: "8月" },
          { value: "09", label: "9月" },
          { value: "10", label: "10月" },
          { value: "11", label: "11月" },
          { value: "12", label: "12月" },
        ];
      for (let i = year - 20, len = year + 20; i <= len; i++) {
        years.push({
          value: i,
          label: i + "年",
        });
      }
      me.$weui.picker(years, months, {
        title: "选择年月",
        onConfirm: function (r) {
          me.yearmonth = r[0].value + r[1].value;
          me.searchDay();
        },
      });
    },
    open(index) {
      if (index != this.opened)
        this.initChart(this.deal2(this.result.details[index]));

      this.opened = index == this.opened ? -1 : index;
    },
  },
};
</script>

<style scoped>
.canvas-box {
  /* width: 100%;
  height: 100%; */
  overflow-x: scroll;
  background: var(--weui-BG);
}

.list-box {
  margin-top: 5px;
  background: var(--weui-BG);
  width: 100%;
  display: flex;
  justify-content: space-around;
}
.list-box-col {
  text-align: center;
}
.list-box-col p {
  line-height: 40px;
}
.list-box-col__title {
  font-weight: bold;
}
.list-box-col__content {
  font-size: small;
  color: var(--weui-FG-0);
}
.list-box-active:active {
  background: #e0e0e0;
}

.list-cells {
  margin-top: 5px;
  background: var(--weui-BG);
}
.list-cell {
  background-color: #fff;
}
.list-cell__main {
  display: flex;
  padding: 10px 0;
}
.list-cell__index {
  width: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.list-cell__index span {
  border-radius: 50%;
  width: 20px;
  height: 20px;
  color: #fff;
  font-size: 12px;
  line-height: 20px;
  text-align: center;
  background-color: #c0c0c0;
}
.list-cell__content {
  flex: 1;
  height: 36px;
  line-height: 36px;
  font-size: 12px;
  color: #8b8b8b;

  display: flex;
  justify-content: space-between;

  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.list-cell__toggle {
  width: 36px;
  height: 36px;
  line-height: 36px;
  font-size: 12px;
  padding: 0 20px;
}
.gray {
  /* max-height: 300px;
  overflow-y: auto; */
  background: #f4f4f4;
}

.filter-bar {
  width: 100%;
  background: var(--weui-BG-2);
  box-sizing: border-box;
  text-align: center;
  font-size: 13px;
  padding: 11px 0 9px 0;
  color: #9b9b9b;
  margin-bottom: 1px;
  display: flex;
}
.filter-bar span {
  margin: 0 auto;
  flex: 1;
  position: relative;
}
.filter-item__select {
  position: absolute;
  margin: 0;
  padding: 0;
  border: 0;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}
.filter-item__select option {
  color: var(--weui-FG-0);
  background: var(--weui-BG-2);
}
@media screen and (min-width: 500px) {
  .filter-bar {
    padding: 6px 0 2px 0;
  }
  .list-scroll-wrap {
    width: 100%;
  }
  .list-box-col p {
    line-height: 25px;
  }
}
</style>